// initial state
const state = () => ({
    modal: null
})

// mutations
const mutations = {
    setModal(state, payload) {
        state.modal = payload;
    }
}

export default {
    namespaced: true,
    state,
    mutations
}
